<template>
  <section>
    <section>
      <!-- <pm-Breadcrumb :home="home" :model="items_bread" /> -->
      <div class="row">
        <div class="col-md-10">
          <h2 class="titulo-links-escolha">Presenças</h2>
        </div>
        <div class="col-md-2">
          <pm-Button
            label="Voltar"
            class="p-button-danger"
            icon="pi pi-angle-left"
            iconPos="left"
            style="float: right; margin-top: 25px; margin-bottom: 25px"
            @click="voltarParTurma()"
          />
        </div>
      </div>

      <div
        v-if="carregandoPagina"
        class="col-md-12"
        style="text-align: center; padding-top: 255px"
      >
        <pm-ProgressSpinner />
      </div>

      <div class="row">
        <div class="col-md-12" v-if="!carregandoPagina && acesso.visualizar">
          <section>
            <div class="pm-card">
              <div class="row">
                <div class="col-md-12">
                  <h2
                    class="titulo-links-escolha"
                    style="margin-top: 10px !important"
                  >
                    Alunos(as)
                  </h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" v-if="turma_id">
                  <div class="row" v-if="!ensino_basico">
                    <div
                      class="col-md-3"
                      v-if="
                        this.tipo_segmento == 2 ||
                          (this.tipo_segmento == 3 && selectSerie.tipo == 2) ||
                          (selectSerie.possui_mais_de_um_professor &&
                            !ensino_basico)
                      "
                    >
                      <label>Selecione uma Disciplina:</label>
                      <select
                        class="p-inputtext p-component"
                        v-model="disciplina_id"
                        @change="buscarPresencasDisciplina()"
                        style="
                          appearance: revert !important;
                          width: 100% !important;
                        "
                      >
                        <!--<option  v-if="mes == 0">Selecione um mês</option>-->
                        <option
                          :value="n.id"
                          v-for="n in disciplina"
                          :key="n.id"
                        >
                          {{ n.nome }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-12" style="margin-top: 25px">
                      <selectCalendario2
                        v-if="
                          ((this.tipo_segmento != 1 &&
                            this.tipo_segmento != 0) ||
                            selectSerie.possui_mais_de_um_professor) &&
                            disciplina_id != 0
                        "
                        @exibirTabela="exibirTabela"
                        @test="montarCalendarioProfessor"
                        :mes_nome="this.mes_exib_selec"
                        :mes="this.mes_selec"
                        :tabelaDias="tabelaDias"
                        :mesNumero="mes_numeral"
                        :diaSelecionado="this.info.dia"
                        @dialogAction="dialogAction"
                      />
                      <selectCalendario2
                        v-if="
                          (this.tipo_segmento == 1 ||
                            this.tipo_segmento == 0) &&
                            !selectSerie.possui_mais_de_um_professor &&
                            disciplina_id != 0
                        "
                        @exibirTabela="exibirTabela"
                        @test="montarCalendarioProfessor"
                        :mes_nome="this.mes_exib_selec"
                        :mes="this.mes_selec"
                        :tabelaDias="tabelaDias"
                        :mesNumero="mes_numeral"
                        :diaSelecionado="this.info.dia"
                        @dialogAction="dialogAction"
                      />
                    </div>
                    <div class="col-md-12" style="margin-top: 10px"></div>
                  </div>

                  <div class="row" v-else>
                    <div class="col-md-3">
                      <label>Selecione uma Disciplina:</label>
                      <select
                        class="p-inputtext p-component"
                        v-model="arr_disciplina_id"
                        @change="
                          //disciplinaFantasia(this.arr_disciplina_id),
                          buscarPresencasDisciplina()
                        "
                        style="
                          appearance: revert !important;
                          width: 100% !important;
                        "
                      >
                        <option
                          :value="{
                            id: n.disciplina_id,
                            disc_fantasia_id: n.disc_fantasia_id,
                          }"
                          v-for="n in disciplinas_fantasia"
                          :key="n.id"
                        >
                          {{ n.nome_disciplina }}
                        </option>
                      </select>
                    </div>

                    <div
                      class="col-md-12"
                      v-if="tabelaDias.length > 0"
                      style="margin-top: 25px"
                    >
                      <selectCalendario2
                        @exibirTabela="exibirTabela"
                        @test="montarCalendarioProfessor"
                        :mes_nome="this.mes_exib_selec"
                        :mes="this.mes_selec"
                        :tabelaDias="tabelaDias"
                        :mesNumero="mes_numeral"
                        :diaSelecionado="this.info.dia"
                        @dialogAction="dialogAction"
                      />
                    </div>
                    <div class="col-md-12" style="margin-top: 10px"></div>
                  </div>
                </div>
                <div class="col-md-12" style="margin-top: 10px"></div>
              </div>
              <div v-if="presencasAlunosView">
                <div v-if="abrirComponete && turma_id && disciplina_id != 0">
                  <CalendarioVisualizar
                    @test="montarCalendarioProfessor"
                    @abrirConteudo="abrirConteudo"
                    @abrirTodosOsConteudo="abrirTodosOsConteudo"
                    :acesso="acesso"
                    :presencasAlunosView="presencasAlunosView"
                    :tabelaDias="tabelaDias"
                    :mes_nome="this.mes_exib_selec"
                    :mes_sel="this.mes_selec"
                    :mes="this.mes_exib_selec"
                    :disciplina_id="disciplina_id"
                    :disciplinas_fantasia_id="disciplinas_fantasia_id"
                    :turma_id = "turma_id"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <pm-Dialog
        header="Enviar presença"
        v-model:visible="displayMaximizable"
        :style="{ width: '100vw' }"
        :maximizable="true"
        :modal="true"
      >
        <div class="row">
          <div class="row field col-12" v-if="this.info.dataSelecionada != ''">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12" v-if="info.dataSelecionada">
                  <p class="text-01-presenca">
                    Disciplina:
                    <b>{{ disciplina_nome }}</b>
                  </p>
                  <h2 class="text-01-presenca">
                    Data selecionada: <b>{{ info.dataSelecionada }}</b>
                  </h2>
                </div>
                <div
                  class="field col-12 md:col-3 lg:col-3"
                  v-if="presenca_infinita == 1"
                >
                  <label style="margin-right: 10px;">Quantidade de presenças</label>
                  <select
                    class="p-inputtext p-component"
                    v-model="qdt_presenca"
                    style="appearance: revert !important; width: 27% !important"
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                  </select>
                </div>
              </div>
              <div class="p-fluid formgrid grid">
                <div class="row">
                  <div
                    class="row"
                    v-if="selectable && info.dia"
                    style="margin-top: 5px"
                  >
                    <h4 class="title-presenca-table">Alunos da Turma</h4>
                    <table-prof-presenca01
                      @marcarPresenca="marcarPresenca"
                      :alunos="alunos"
                      :acesso="acesso"
                      :st_segmento="this.segmento_id"
                      :etapaDeEnvioDePresenca="etapaDeEnvioDePresenca"
                    />
                  </div>

                  <div
                    class="row"
                    v-if="this.selectable && info.dia"
                    style="width: 100%; position: fixed; bottom: 0; right: 28px; display: grid; justify-content: end;"
                  >
                    <va-inner-loading
                      class="py-3"
                      style="width: 100%"
                      :loading="isLoading"
                    >
                      <button
                        class="btn btn-primary"
                        @click="presencaEnviar()"
                        v-if="acesso.cadastrar && this.alunos.length"
                      >
                        Enviar Presença
                      </button>
                    </va-inner-loading>
                  </div>

                  <div
                    v-if="
                      editarOk &&
                        (this.tipo_segmento == 1 || this.serie_tipo == 1)
                    "
                  >
                    <editarFundamental1
                      @marcarPresenca="marcarPresenca"
                      :alunos="alunos"
                      @EditarPresencaDaTurma="EditarPresencaDaTurma"
                      @fecharEditarFundamentalUm="fecharEditarFundamentalUm"
                    />
                  </div>

                  <div
                    v-if="
                      editarOk &&
                        (this.tipo_segmento == 2 || this.serie_tipo == 2)
                    "
                  >
                    <editarFundamental2
                      @marcarPresencaFundamentalDois="
                        marcarPresencaFundamentalDois
                      "
                      :alunos="alunos"
                      @EditarPresencaDaTurma="EditarPresencaDaTurma"
                      @fecharEditarFundamentalUm="fecharEditarFundamentalUm"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <h3>Conteúdo Aplicado</h3>
              <modalConteudoAplicado
                edicao="0"
                :dados="{
                  disc_fantasia_id: 0,
                  disciplina_id: this.disciplina_id,
                  data: this.info.dataSelecionada,
                  turma_id: this.turma_id,
                }"
                :mes_c="this.mes_c"
                :completo="0"
                @changeStatusModal="changeStatusModal"
                @saveAppliedContent ="saveAppliedContent"
                @conteudoObg ="conteudoObg"
              />
            </div>
          </div>
        </div>
        <template #footer> </template>
      </pm-Dialog>

      <pm-Dialog
        header="Conteúdo Aplicado" v-model:visible="displayModalConteudo" :style="{width: '100vw'}" :maximizable="true" :modal="true">
        <modalConteudoAplicado
          edicao="1"
          :dados="this.dados"
          :mes_c="this.mes_c"
          :completo="this.completo"
          @changeStatusModal="changeStatusModal"
          @saveAppliedContent ="saveAppliedContent"
          @conteudoObg ="conteudoObg"
        />
      </pm-Dialog>
    </section>
  </section>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";
import { Escola } from "@/class/escolas";
import { LoginInfo } from "@/class/login";
import { Calendario } from "@/class/calendario";
import { Turma } from "@/class/turma";
import { Presenca } from "@/class/presenca";
import { DisciplinaEscolar } from "@/class/disciplina";
import { SegmentoEscolar } from "@/class/segmentoEscolar.js";
import { Verificar } from "@/class/verificar.js";
import { Servidores } from "@/class/servidores";
import { SeriesEscolar } from "@/class/serie.js";

import selectCalendario2 from "@/components/presenca/selectCalendario2.vue";
import CalendarioVisualizar from "@/components/presenca/calendarioVisualizar.vue";

import tableProfPresenca01 from "@/components/presenca/tableProfPresenca01.vue";
import editarFundamental1 from "@/components/presenca/editarFundamental1.vue";
import editarFundamental2 from "@/components/presenca/editarFundamental2.vue";

import modalConteudoAplicado from "@/components/conteudo_aplicado/modal-conteudo-aplicado.vue";
import { PlanejamentoPedagogico } from "@/class/planejamentopedagogico";

import { Configuracao } from "@/class/configuracao";

export default defineComponent({
  props: {
    escola_id: {
      required: true,
    },
    segmento_id: {
      required: true,
    },
    periodo_id: {
      required: true,
    },
    turma_id: {
      required: true,
    },
    pg: {},
  },
  components: {
    selectCalendario2,
    CalendarioVisualizar,
    tableProfPresenca01,
    editarFundamental1,
    editarFundamental2,
    modalConteudoAplicado
  },
  data() {
    const columns = [
      { key: "nome", label: "Nome", sortable: true },
      { key: "ano", label: "Ano", sortable: true },
      { key: "aluno", label: "Ação" },
    ];
    return {
      base_url: axios.defaults.baseURL.replace("/api/v1", ""),

      home: { icon: "pi pi-home", to: "/admin/painel-adm" },
      items_bread: [{ label: "Presenças" }],
      filter: "",
      columns,

      abrirComponete: false,
      maiorIndex: 0,
      tipo_segmento: 0,
      serie_tipo: 0,
      tabelaDias: [],
      tabelaDiasApenasAnosLetivoColunas: [],
      info: [],
      dataSelecionaFormatoEUA: "",
      presencasAlunosView: [],
      mes_selec: "",
      mes_exib_selec: "",
      todosOsAlunos: [],
      displayMaximizable: false,
      selectable: true,
      isLoading: false,
      mesLoading: false,
      porcentagemParaSerAprovado: 70,

      aluno: 0,
      alunos: [],
      presenca: 0,
      theturma: null,
      alunosPresente: [],
      presenca: 0,
      professor_id: null,
      segmentoInfo: null,
      serieInfo: null,
      professorInfo: "",
      mes: 0,
      disciplina: [],
      presencas: [],
      disciplina_id: 0,
      disciplina_nome: null,

      acesso: {
        visualizar: 1,
        cadastrar: 1,
        editar: 1,
        deletar: 1,
      },
      meses: [
        { numero: "01", palavra: "janeiro" },
        { numero: "02", palavra: "fevereiro" },
        { numero: "03", palavra: "marco" },
        { numero: "04", palavra: "abril" },
        { numero: "05", palavra: "maio" },
        { numero: "06", palavra: "junho" },
        { numero: "07", palavra: "julho" },
        { numero: "08", palavra: "agosto" },
        { numero: "09", palavra: "setembro" },
        { numero: "10", palavra: "outubro" },
        { numero: "11", palavra: "novembro" },
        { numero: "12", palavra: "dezembro" },
      ],
      tabelaPresencasColunas: [],
      carregandoPagina: false,
      presenca_infinita: 0,
      qdt_presenca: 1,
      ensino_basico: 0,
      disciplinas_fantasia: [],
      disciplinas_fantasia_id: 0,
      contar_render: 0,

      displayModalConteudo:false,
      dados:[],
      mes_c:"",
      completo:0,
      conteudoAplicado:[],
      conteudoObrigatorio:0,
      nVazio:[],
      nV:0
    };
  },
  methods: {
    conteudoObg(valor){
      this.conteudoObrigatorio = valor
    },
    changeStatusModal(val){
      if(val == 1){
       this.displayModalConteudo = false
      }else{
        this.displayModalConteudo = true
      }
    },
    async abrirTodosOsConteudo(mes,it){
      this.mes_c = "";
      this.mes_c = mes;
      this.completo = 1;
      this.dados = it;
      this.displayModalConteudo = true;
    },
    async abrirConteudo(mes,it){
      this.mes_c = "";
      this.mes_c = mes;
      this.completo = 0;
      this.dados = [];
      this.dados = it;
      this.displayModalConteudo = true;
    },
    disciplinaFantasia(n) {
      this.disciplinas_fantasia_id = n.disc_fantasia_id;
      this.disciplina_id = n.id;
    },

    async professorPrincipal(turma_id) {
      const playload = {
        turma_id: turma_id,
        professor_id: 0,
      };
      const res = await Servidores.ProfessorPrincipalShow(playload);
      if (res.data.length > 0) {
        this.ensino_basico = 1;
        this.disciplinas_fantasia = res.data;
      } else {
        this.ensino_basico = 0;
      }
    },

    async getQdtPresenca() {
      const data = await axios.get(
        "/config/sistema/presenca/" + this.segmento_id + "/segmento"
      );
      this.presenca_infinita = data.data.presenca_infinita;
    },
    //Receber todos os dia que possuem presencas
    receberTodosOsDiasQueExistemPresencas() {
      const myPresencasDias = new Set();
      for (let i = 0; i < this.presencasAlunosView.length; i++) {
        for (let j = 0; j < this.presencasAlunosView[i].presencas.length; j++) {
          if (
            !myPresencasDias.has(this.presencasAlunosView[i].presencas[j].dia)
          ) {
            myPresencasDias.add(this.presencasAlunosView[i].presencas[j].dia);
          }
        }
      }
      return Array.from(myPresencasDias).sort((a, b) => a - b);
    },
    //Buscar todas as presencas que existem em um dia X
    todasAsPresencasQueExistemNoDia(dia) {
      const mySet = new Set();
      const todasAsPresencasNoDia = [];
      for (let i = 0; i < this.presencasAlunosView.length; i++) {
        for (let j = 0; j < this.presencasAlunosView[i].presencas.length; j++) {
          if (
            !mySet.has(this.presencasAlunosView[i].presencas[j].data) &&
            dia == this.presencasAlunosView[i].presencas[j].dia
          ) {
            todasAsPresencasNoDia.push(
              this.presencasAlunosView[i].presencas[j]
            );
            mySet.add(this.presencasAlunosView[i].presencas[j].data);
            //Para add dias para criar as colunas da tabela
            this.tabelaPresencasColunas.push(dia);
          }
        }
      }
      return todasAsPresencasNoDia.sort(function (a, b) {
        return a.presenca_id - b.presenca_id;
      });
    },
    criarTabelaDePresencasParaCadaAluno(mapOfValues) {
      //Para exibir os dados na tabela de presenca
      for (var i = 0; i < this.presencasAlunosView.length; i++) {
        this.presencasAlunosView[i].presencas1 = [];
      }
      for (const dia of mapOfValues) {
        var presencasDoAluno = this.todasAsPresencasQueExistemNoDia(dia);
        for (var i = 0; i < this.presencasAlunosView.length; i++) {
          for (var j = 0; j < presencasDoAluno.length; j++) {
            //Verificar se o aluno i possue a preseja j
            const found = this.presencasAlunosView[i].presencas.find(
              (element) => element.data == presencasDoAluno[j].data
            );

            if (found != undefined) {
              this.presencasAlunosView[i].presencas1.push(found);
            } else {
              const aluno = {
                data: presencasDoAluno[j].data,
                disciplina_id: presencasDoAluno[j].disciplina_id,
                disc_fantasia_id: presencasDoAluno[j].disc_fantasia_id,
                escola_id: presencasDoAluno[j].escola_id,
                segmento_id: presencasDoAluno[j].segmento_id,
                serie_id: presencasDoAluno[j].serie_id,
                professor_id: presencasDoAluno[j].professor_id,
                turma_id: presencasDoAluno[j].turma_id,
              };
              this.presencasAlunosView[i].presencas1.push(aluno);
            }
          }
        }
      }
    },
    voltarParTurma() {
      this.$router.push({
        name: "coordenacao-turma-hab",
        params: { pg: this.pg },
      });
    },
    fecharEditarFundamentalUm() {
      this.editarOk = !this.editarOk;
    },
    async listarEscolas() {
      const esc = await Escola.obtemTodos();

      for (const el of esc.data) {
        const novo = {
          id_: el.id,
          id: el.id,
          logradouro: el.logradouro,
          bairro: el.bairro,
          cep: el.cep,
          cidade: el.cidade,
          cnpj: el.cnpj,
          email: el.email,
          estado: el.estado,
          nome: el.nome,
          numero: el.numero,
          items: [
            {
              label: "Editar Escola",
              icon: "pi pi-pencil",
              command: () => {
                this.editarEscola(el.id);
              },
            },
            {
              label: "Informações da Escola",
              icon: "pi pi-search-plus",
              command: () => {
                this.editarInfo(el.id);
              },
            },
          ],
        };
        this.escolas.push(novo);
      }
    },
    async presenca_tudo_turma(id) {
      const data = await Turma.obtemPresencaTudo(id);
      this.alunos = data.data;
    },
    async listarTudo() {
      try {
        const token = sessionStorage.getItem("token");
        const whoiam = await LoginInfo.WhoIam(token);
        const calendario = await Calendario.obtemTodos();

        if (whoiam.data.funcao != 5) {
          this.$router.push({ name: "login" });
        }
      } catch (e) {}
    },

    async buscarPresencasDisciplina() {
      const date = new Date();
      const today = date.getDate();
      const currentMonth = date.getMonth() + 1;
      if (currentMonth == 1) {
        await this.montarCalendarioProfessor("janeiro", "Janeiro");
      }
      if (currentMonth == 2) {
        await this.montarCalendarioProfessor("fevereiro", "Fevereiro");
      }
      if (currentMonth == 3) {
        await this.montarCalendarioProfessor("marco", "Março");
      }
      if (currentMonth == 4) {
        await this.montarCalendarioProfessor("abril", "Abril");
      }
      if (currentMonth == 5) {
        await this.montarCalendarioProfessor("maio", "Maio");
      }
      if (currentMonth == 6) {
        await this.montarCalendarioProfessor("junho", "Junho");
      }
      if (currentMonth == 7) {
        await this.montarCalendarioProfessor("julho", "Julho");
      }
      if (currentMonth == 8) {
        await this.montarCalendarioProfessor("agosto", "Agosto");
      }
      if (currentMonth == 9) {
        await this.montarCalendarioProfessor("setembro", "Setembro");
      }
      if (currentMonth == 10) {
        await this.montarCalendarioProfessor("outubro", "Outubro");
      }
      if (currentMonth == 11) {
        await this.montarCalendarioProfessor("novembro", "Novembro");
      }
      if (currentMonth == 12) {
        await this.montarCalendarioProfessor("dezembro", "Dezembro");
      }
    },

    async montarCalendarioProfessor(mes, mesExibir) {
      //await this.professorPrincipal(this.turma_id);
      if (
        (this.ensino_basico == 1 && this.contar_render == 0) ||
        (this.selectSerie.possui_mais_de_um_professor == 1 &&
          this.contar_render == 0)
      ) {
        this.contar_render = this.contar_render + 1;
        return false;
      }
      this.tabelaDias = [];
      this.tabelaPresencasColunas = [];
      this.presencasAlunosView = [];
      this.tabelaDiasApenasAnosLetivoColunas = [];

      this.carregandoPagina = true;
      this.mes_selec = mes;
      this.mes_exib_selec = mesExibir;
      this.mesLoading = true;

      this.info.dia = "";
      this.info.semana = "";
      this.info.dataSelecionada = "";
      const anoSelect = sessionStorage.getItem("anoSelecionado");
      this.info.ano = anoSelect;

      async function chamarCalendarioProf(
        mes,
        anoSelect,
        disciplina_id,
        turma_id,
        segmentoInfo,
        serieInfo,
        disciplinas_fantasia_id = 0
      ) {
        const novo = {
          disciplina_id: disciplina_id,
          mes: mes,
          turma_id: turma_id,
          segmento_id: segmentoInfo,
          serie: serieInfo,
          ano: anoSelect,
        };
        let data;
        if (disciplinas_fantasia_id < 1) {
          data = await Presenca.presencaMontarCalendarioProfessor(novo);
        } else {
          data = await Presenca.presencaMontarCalendarioProfessorDiscFantasia(
            novo,
            disciplinas_fantasia_id
          );
        }
        return data.data;
      }

      this.turmaAlunos();

      async function tipoSegmentoDisciplina(
        tipo_segmento,
        serie_tipo,
        selectSerie,
        funcaoDoUsuario,
        disciplina_id,
        ensino_basico,
        disciplinas_fantasia,
        disciplinas_fantasia_id,
        disciplina
      ) {
        const arr = {
          disciplina_id: 0,
          disciplina_nome: " ",
        };

        if (!ensino_basico) {
          if (
            (tipo_segmento == 1 || (tipo_segmento == 3 && serie_tipo == 1)) &&
            !selectSerie
          ) {
            if (
              funcaoDoUsuario != 1 &&
              funcaoDoUsuario != 2 &&
              funcaoDoUsuario != 7
            ) {
              arr.disciplina_id = 1;
            }

            arr.disciplina_id = 1;
            arr.disciplina_nome = "Todas as Disciplinas";
          } else if (tipo_segmento == 0) {
            arr.disciplina_id = 2;
            arr.disciplina_nome = "Educação Infantil";
          } else {
            arr.disciplina_id = disciplina_id;
            const busca_disciplina = disciplina.find(
              (element) => element.id == disciplina_id
            );
            if (busca_disciplina) {
              arr.disciplina_nome = busca_disciplina.nome;
            }
          }
        } else {
          arr.disciplina_id = disciplina_id;
          if (disciplina_id > 1) {
            const busca_disciplina = disciplinas_fantasia.find(
              (element) => element.disciplina_id == disciplina_id
            );
            if (busca_disciplina) {
              arr.disciplina_nome = busca_disciplina.nome_disciplina;
            }
          } else {
            const busca_disciplina = disciplinas_fantasia.find(
              (element) => element.disc_fantasia_id == disciplinas_fantasia_id
            );
            if (busca_disciplina) {
              arr.disciplina_nome = busca_disciplina.nome_disciplina;
            } else {
              arr.disciplina_nome = "Todas as Disciplinas";
            }
          }
        }

        return arr;
      }

      tipoSegmentoDisciplina(
        this.tipo_segmento,
        this.serie_tipo,
        this.selectSerie.possui_mais_de_um_professor,
        this.funcaoDoUsuario,
        this.disciplina_id,
        this.ensino_basico,
        this.disciplinas_fantasia,
        this.disciplinas_fantasia_id,
        this.disciplina
      )
        .then((res) => {
          this.disciplina_id = res.disciplina_id;
          this.disciplina_nome = res.disciplina_nome;
        })
        .catch((e) => {
          console.log(e);
        });

      //receber mês números
      const found = this.meses.find((element) => element.palavra == mes);
      this.mes_numeral = found.numero;

      await chamarCalendarioProf(
        mes,
        anoSelect,
        this.disciplina_id,
        this.turma_id,
        this.segmento_id,
        this.periodo_id,
        this.disciplinas_fantasia_id
      )
        .then((res) => {
          this.tabelaDias = res;
        })
        .catch((e) => {
          if (e.response.data.erro) {
            setTimeout(() => {
              this.$vaToast.init({
                message: e.response.data.erro,
                iconClass: "fa-star-o",
                position: "top-right",
                duration: 3500,
                fullWidth: false,
                color: "danger",
              });
            }, 50);
          } else {
            setTimeout(() => {
              this.$vaToast.init({
                message: e.response.data.message,
                iconClass: "fa-star-o",
                position: "top-right",
                duration: 3500,
                fullWidth: false,
                color: "danger",
              });
            }, 500);
          }
        })
        .finally(() => {
          //Apenas com dia letivo
          for (let i = 0; i < this.tabelaDias.length; i++) {
            if (this.tabelaDias[i].letivo == "0") {continue;}
            if (this.tabelaDias[i].dia.length == 1)
              {this.tabelaDias[i].dia = "0" + this.tabelaDias[i].dia;}
            this.tabelaDiasApenasAnosLetivoColunas.push(this.tabelaDias[i]);
          }
          this.mesLoading = false;
        });

      async function presencaMensal(
        disciplina_id,
        mes,
        turma_id,
        anoSelect,
        data_inicial_matricula,
        data_final_matricula,
        disciplinas_fantasia_id
      ) {
        //presencas visu
        const res = {
          disciplina_id: disciplina_id,
          mes: mes,
          turma_id: turma_id,
          ano: anoSelect,
        };
        const data1 = await Presenca.mesesVisu(res, disciplinas_fantasia_id);
        const arr = [];

        for (const el of data1.data) {
          const info = {
            id: el.aluno.id,
            nome: el.aluno.nome + " " + el.aluno.sobrenome,
            evento_saida: el.evento_saida,
            presencas: [],
            cntPresencas: 0,
            data_entrada_turma: el.data_entrada_na_turma,
            data_entrada_turma_br: el.data_entrada_na_turma_br,
            entrou_no_prazo_certo: el.entrou_no_prazo_certo,
            status: el.status,
            transferido: el.transferido,
            saiu_da_turma_data: el.saiu_da_turma_data,
            entrou_na_turma_por_transferencia:
              el.entrou_na_turma_por_transferencia,
            saiu_da_turma_data_formato_br: el.saiu_da_turma_data_formato_br,
            entradaESaidaDaTurma: el.entradaESaidaDaTurma,
            historico_saida_entrada_turma: el.historico_saida_entrada_turma,
            turma_id: el.turma_id,
          };

          for (const el1 of el.presenca) {
            const novo = {
              presenca_id: el1.id,
              aluno_id: el.aluno.id,
              data: el1.data,
              disciplina_id: el1.disciplina_id,
              escola_id: el1.escola_id,
              id_presenca: el1.id,
              justificacao_conteudo: el1.justificacao_conteudo,
              justificada_falta: el1.justificada_falta,
              presenca: el1.presenca,
              professor_id: el1.professor_id,
              segmento_id: el1.segmento_id,
              serie_id: el1.serie_id,
              turma_id: el1.turma_id,
              disc_fantasia_id: el1.disc_fantasia_id,
              dia: "",
            };
            //contar presencas
            info.cntPresencas += el1.presenca;
            //receber dia
            let receberDia = novo.data.split("-");
            receberDia = receberDia[2].split(" ");
            novo.dia = receberDia[0];
            info.presencas.push(novo);
          }
          arr.push(info);
        }
        return arr;
      }

      await presencaMensal(
        this.disciplina_id,
        mes,
        this.turma_id,
        anoSelect,
        this.data_inicial_matricula,
        this.data_final_matricula,
        this.disciplinas_fantasia_id
      )
        .then((res) => {
          this.presencasAlunosView = res;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.tabelaPresencasColunas = [];
          this.criarTabelaDePresencasParaCadaAluno(
            this.receberTodosOsDiasQueExistemPresencas()
          );
          this.presencasAlunosView[0].tableColuna = this.tabelaPresencasColunas;
        });

      this.carregandoPagina = false;
      this.abrirComponete = true;
      //abrir modal
      return true;
    },

    dialogAction() {
      this.alunos = [];

      for (const el of this.todosOsAlunos) {
        let dataDeEntradaNaTurma = el.created_at.split("T");
        dataDeEntradaNaTurma = dataDeEntradaNaTurma[0].substring(0, 10);
        //Verificar se a data que o aluno entrou na turma é menor ou igual a data selecionada. E, se o aluno foi transferido, se a data que foi transferido já chegou. Se chegou nao pode mais lancar presenca
        if (
          dataDeEntradaNaTurma <= this.dataSelecionaFormatoEUA &&
          (el.saiu_da_turma_data == null ||
            this.dataSelecionaFormatoEUA < el.saiu_da_turma_data)
        ) {
          this.alunos.push(el);
        }
      }
      if (!this.alunos.length) {
        this.$vaToast.init({
          message: "A turma não tinha alunos na data selecionada!",
          iconClass: "fa-star-o",
          position: "top-right",
          color: "warning",
          duration: 3000,
          fullWidth: false,
        });
      } else {
        this.displayMaximizable = true;
      }
    },

    async exibirTabela(dia, semana, mes, mesLetra) {
      this.editarOk = false;
      this.info.dia = dia;
      this.info.mes = mesLetra;
      this.info.semana = semana;
      if (dia.length == 1) {dia = "0" + dia;}

      this.info.dataSelecionada =
        String(dia).padStart(2, "0") +
        "/" +
        mes.padStart(2, "0") +
        "/" +
        this.info.ano;
      this.dataSelecionaFormatoEUA =
        this.info.ano + "-" + mes + "-" + String(dia).padStart(2, "0");
    },

    async turmaAlunos() {
      this.todosOsAlunos = [];
      const data = await Turma.obtemAlunosTurma(this.turma_id);
      this.todosOsAlunos = data.data;
    },

    marcarPresenca(n, item) {
      item.presente = n;
    },

    marcarPresencaFundamentalDois(chamada, n, item) {
      if (chamada == 1) {item.presenca_1 = n;}
      else {item.presenca_2 = n;}
    },

    async saveAppliedContent(conteudo, envio){
       
       for (let i = 0; i < conteudo.length; i++) {
         if(conteudo[i].texto.length > 0 ){
           this.nVazio[i] = 1;
         }else{
           this.nVazio[i] = 0;
         }
       }
 
       let sum = 0;
       for (let i = 0; i < conteudo.length; i++) {
         sum+=this.nVazio[i];
       }
       
       if(sum == 0){
         sessionStorage.setItem("conteudoObrigatorio", 0);
         this.conteudoObg(0);
       }
 
       if(envio === 1){
         // salva o conteudo na Api
         for (let i = 0; i < conteudo.length; i++) {
           await PlanejamentoPedagogico.addPlanejamentoProf(conteudo[i]); 
         }
       }else{
         // guarda em variavel
         this.conteudoAplicado = [];
         this.conteudoAplicado = conteudo
       }
     },

    async presencaEnviar() {
      try {
        this.abrirComponete = false;
        this.carregandoPagina = true;
        this.alunosPresente = [];
        //array dos alunos
        for (let i = 0; i < this.alunos.length; i++) {
          if (this.alunos[i].presente == undefined) {
            alert("Adicione as informações de presença para todos os alunos!");
            return false;
          }
          const novo = {
            aluno_id: this.alunos[i].id,
            presenca: this.alunos[i].presente,
            justificada_falta: 0,
            justificacao_conteudo: "",
          };
          this.alunosPresente.push(novo);
        }

        //2022-05-26 10:38:11
        //Receber a hora atual
        const now = new Date();
        let horas = String(now.getHours());
        let minutos = String(now.getMinutes());
        let segundos = String(now.getSeconds());
        if (horas.length == 1) {horas = "0" + horas;}
        if (minutos.length == 1) {minutos = "0" + minutos;}
        if (segundos.length == 1) {segundos = "0" + segundos;}

        const horaAtual = horas + ":" + minutos + ":" + segundos;

        //Data selecionada pelo usuário
        const dataFormatoUSA = this.info.dataSelecionada.split("/");
        const dataAtual =
          dataFormatoUSA[2] + "-" + dataFormatoUSA[1] + "-" + dataFormatoUSA[0];
        const dataEHora = dataAtual + " " + horaAtual;

        async function criarPresenca(
          alunosPresente,
          segmentoInfo,
          escola_id,
          turma_id,
          serieInfo,
          disciplina_id,
          dataEHora,
          qdt_presenca,
          disciplinas_fantasia_id
        ) {
          if (!alunosPresente) {
            throw new Error("alunosPresente is null");
          }

          const info = {
            segmento_id: segmentoInfo,
            escola_id: escola_id,
            turma_id: turma_id,
            serie_id: serieInfo,
            professor_id: 0,
            disciplina_id: disciplina_id,
            data: dataEHora,
            qdt_presenca: qdt_presenca,
          };

          let data;
          if (disciplinas_fantasia_id < 1) {
            try {
              data = await  Presenca.criarPresencaDosAlunos(alunosPresente, info);
            } catch (error) {
              if (error.response && error.response.status === 429) {
                this.$vaToast.init({
                  message:
                    'Limite de solicitações atingido. Aguarde um momento e tente novamente.',
                  iconClass: "fa-star-o",
                  position: "bottom-left",
                  duration: 3500,
                  fullWidth: false,
                  color: "danger",
                });
              } else {
                alert("Ocorreu um erro ao processar a solicitação.");
              }
              throw error;
            }
          } else {
            if (!info) {
              throw new Error("info is null");
            }

            info.disc_fantasia_id = disciplinas_fantasia_id;
            try {
              data = await  Presenca.criarPresencaDosAlunos(alunosPresente, info);
            } catch (error) {
              if (error.response && error.response.status === 429) {
                this.$vaToast.init({
                  message:
                    'Limite de solicitações atingido. Aguarde um momento e tente novamente.',
                  iconClass: "fa-star-o",
                  position: "bottom-left",
                  duration: 3500,
                  fullWidth: false,
                  color: "danger",
                });
              } else {
                alert("Ocorreu um erro ao processar a solicitação.");
              }
              throw error;
            }
          }
          return data;
        }


        this.displayMaximizable = false;

        await criarPresenca(
          this.alunosPresente,
          this.segmento_id,
          this.escola_id,
          this.turma_id,
          this.periodo_id,
          this.disciplina_id,
          dataEHora,
          this.qdt_presenca,
          this.disciplinas_fantasia_id
        )
          .then((res) => {
            this.$vaToast.init({
              message: "Presença enviada com sucesso!",
              iconClass: "fa-star-o",
              position: "top-right",
              color: "success",
              duration: 3000,
              fullWidth: false,
            });
          })
          .catch((e) => {
            this.$vaToast.init({
              message: e.response.data.erro,
              iconClass: "fa-star-o",
              position: "top-right",
              color: "danger",
              duration: 3000,
              fullWidth: false,
            });
          })
          .finally(() => {
            this.abrirComponete = true;
            this.qdt_presenca = 1;
            this.turmaAlunos();
            this.montarCalendarioProfessor(this.mes_selec, this.mes_exib_selec);
            this.isLoading = false;
          });

        this.saveAppliedContent(this.conteudoAplicado, 1)
        this.presencasAlunosView = [];
      } catch (e) {
        this.$vaToast.init({
          message: "Error ao enviar presença!",
          iconClass: "fa-star-o",
          position: "top-right",
          color: "danger",
          duration: 3000,
          fullWidth: false,
        });
        this.isLoading = false;
      }
    },

    async EditarPresencaDaTurma(alunos) {
      try {
        this.alunosPresente = [];
        for (let i = 0; i < alunos.length; i++) {
          if (alunos[i].presente != undefined) {
            const novo = {
              aluno_id: alunos[i].aluno_id,
              id: alunos[i].id,
              nome: alunos[i].nome,
              turma_id: alunos[i].turma_id,
              presenca_1: alunos[i].presente,
              presenca_2: null,
              ano: this.info.ano,
              mes: this.info.mes,
              dia: this.info.dia,
            };
            this.alunosPresente.push(novo);
          } else {
            const novo = {
              aluno_id: alunos[i].aluno_id,
              id: alunos[i].id,
              nome: alunos[i].nome,
              turma_id: alunos[i].turma_id,
              presenca_1: alunos[i].presenca_1,
              presenca_2: alunos[i].presenca_2,
              ano: this.info.ano,
              mes: this.info.mes,
              dia: this.info.dia,
            };
            this.alunosPresente.push(novo);
          }
        }

        //Gerar presencas

        const pf = await Servidores.buscarServidorIdLogin(this.st_professor_id);
        const data = await Presenca.EditarPresencaDaTurma(
          this.alunosPresente,
          pf.data.id,
          this.disciplinaSelecionadaPeloProf.turma_disciplina_id,
          this.infoParaEnviar.turma_id,
          this.qdt_presenca
        );

        this.$vaToast.init({
          message: "Editado com sucesso!",
          iconClass: "fa-star-o",
          position: "top-right",
          color: "success",
          duration: 3000,
          fullWidth: false,
        });
        this.editarOk = false;
      } catch (e) {
        this.$vaToast.init({
          message: "Problema ao editar!",
          iconClass: "fa-star-o",
          position: "top-right",
          color: "danger",
          duration: 3000,
          fullWidth: false,
        });
      }
    },
    async buscarSegmentoALL() {
      //const data = await SegmentoEscolar.obtemTodos();
      const data = await SegmentoEscolar.obtemSegmentosEscola(this.escola_id);
      this.segmentoALL = [];
      for (const el of data.data) {
        if (el.id == 5) {continue;}
        this.segmentoALL.push(el);
      }
    },

    async listaSerie(id) {
      //const data = await SegmentoEscolar.listarSegmentosPorSerie(id);
      const data = await SegmentoEscolar.listarSegmentosPorSerieExistente(this.escola_id,id);

      this.serieALL = data.data;
      return this.seriesALL;
    },

    async listaTurmas() {
      const play = {
        escola: this.escola_id,
        serie: this.periodo_id,
        segmento: this.segmento_id,
      };

      const data = await Turma.pesqTurmaPorSerieSegmento(play);
      this.turmaALL = data.data;

      await this.getQdtPresenca();
    },

    async listarAlunosdaTurma() {
      const data = await Turma.alunoEmUmaTurma(this.turma);
      this.alunoALL = data.data;
    },

    async listaDisciplina() {
      const data = await DisciplinaEscolar.obtemTodosSemId1Turma(this.turma_id);
      this.disciplina = [];
      for (const el of data.data) {
        if (el.na_turma == 1) {
          const novo = {
            id: el.id,
            nome: el.nome,
            status: el.status,
          };
          this.disciplina.push(novo);
        }
      }
    },
  },
  async beforeMount() {
    this.carregandoPagina = true;
    if (this.turma_id == undefined) {
      this.$router.push({ name: "coordenacao-turma-hab" });
    }
    const acesso = await Verificar.AcessoLocal(10);
    await this.listaDisciplina();
    this.acesso.visualizar = acesso.visualizar;
    this.acesso.cadastrar = acesso.cadastrar;
    this.acesso.editar = acesso.editar;
    this.acesso.deletar = acesso.deletar;

    const dataseg = await SegmentoEscolar.obtemUm(this.segmento_id);
    this.tipo_segmento = dataseg.data.tipo;

    const dat = await SeriesEscolar.obtemUm(this.periodo_id);
    this.selectSerie = dat.data;
    if (this.tipo_segmento != 2) {
      this.serie_tipo = dat.data.tipo;
    } else {
      this.serie_tipo = 0;
    }
    this.carregandoPagina = false;
    this.buscarPresencasDisciplina();

    await this.getQdtPresenca();
  },
});
</script>

<style lang="scss" scoped>
.table-example--pagination {
  padding-top: 20px;
  text-align: center;
  text-align: -webkit-center;
}
</style>

<style>
.th_prf {
  background-color: #0067a7 !important;
  color: #fff;
  text-align: left;
  padding: 15px !important;
  padding-left: 25px !important;
  border: 1px solid;
}
.th_prf1 {
  background-color: #2e92d1 !important;
  color: #fff;
  text-align: left;
  padding: 15px !important;
  padding-left: 25px !important;
  border: 1px solid;
}
.tbody_prf {
  border-top: 0px solid currentColor !important;
}
</style>
